import React from 'react';
import '../css/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-meta">
          <span>&copy; {currentYear} <a href="https://www.xchip.in" target="_blank" rel="noopener noreferrer" className="footer-link">www.xchip.in</a>. ENGINEERING TEAM.</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
